import { maybe } from "@saleor/misc";

import { MallShippingLogsUrlQueryParams } from "../urls";
import { MallShippingLogsFilterOpts } from "./filters";

export function getFilterOpts(
  params: MallShippingLogsUrlQueryParams
): MallShippingLogsFilterOpts {
  return {
    event: {
      active: maybe(
        () => [params.event].some(field => field !== undefined),
        false
      ),
      value: maybe(() => params.event, "")
    }
  };
}
